<script>
  import { startPageState } from "./stores";
  import Button from "./Button.svelte";
  import Scene from "./Scene.svelte";
  import StartPage from "./StartPage.svelte";
</script>

<style>
  @font-face {
    font-family: "TTHoves";
    src: local("TTHoves"),
      url("https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/TTHoves-Regular.ttf?v=1660985483630")
        format("truetype");
  }
  @font-face {
    font-family: "PPFormula";
    src: local("PPFormula"),
      url("https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/PPFormula-Medium.otf?v=1660985494853")
        format("opentype");
  }
  @font-face {
    font-family: "PPFormula Bold";
    src: local("PPFormula Bold"),
      url("https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/PPFormula-Extrabold.otf?v=1660986341468")
        format("opentype");
  }
  main {
    font-family: sans-serif;
    text-align: center;
    overflow: hidden;
  }
  :global(body) {
    margin: 0;
    overflow: hidden;
  }
</style>



<main>

<Scene />
	<!-- <h1>Hello CodeSandbox</h1>
	<h2>Start editing to see some magic happen!</h2>
	<Button /> -->
  {#if $startPageState}
<StartPage />
{/if}
</main>